import { useMutation, useQuery } from '@tanstack/react-query'
import { getPayMethods, getPayOrder } from '../services/Services'

export const usePayMethods = (companyId: number) => {
  return useQuery({
    queryKey: ['payMethods', companyId],
    queryFn: () => getPayMethods(companyId),
    enabled: !!companyId,
    select: (data) => {
      if (!data?.body) return { paymentOptions: [], methods: {} }

      const { account, card } = data.body
      let paymentOptions = []

      if (card && card.length > 0) {
        paymentOptions.push('Tarjeta')
      }

      if (account && account.length > 0) {
        const hasType3 = account.some((acc: any) => acc.type === 3)
        const hasType4 = account.some((acc: any) => acc.type === 4)

        if (hasType3) {
          paymentOptions.push('Depósito')
        }
        if (hasType4) {
          paymentOptions.push('Sinpe Móvil')
        }
      }

      return {
        paymentOptions,
        methods: data.body
      }
    }
  })
}

export const useCreatePayOrder = () => {
  return useMutation({
    mutationFn: (data: any) => getPayOrder(data)
  })
}
